import * as React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'

import { RootState, Auth } from 'types'
import { gtmTracking } from 'utils/gtmTracking'
import { trackCampaign } from 'utils/campaignUtils'
import { REACT_APP_DISABLE_TRACKING } from 'env'
import { getLocation } from 'hooks/useHistory'

interface Props {
  children?: React.ReactNode
  auth?: Auth | null
}

class TrackingPixels extends React.Component<Props, {}> {
  componentDidMount() {
    trackCampaign()
  }

  render() {
    if (getLocation().search.includes('cypress=true') || REACT_APP_DISABLE_TRACKING) return this.props.children

    gtmTracking()
    const { children, auth } = this.props
    return (
      <>
        <Helmet>
          {/* <!-- Facebook Pixel Code --> */}
          <script>
            {`!function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window,document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '1563423343787935');
              fbq('track', 'PageView');`}
          </script>
          <noscript>
            {`<img height="1" width="1" src="https://www.facebook.com/tr?id=1563423343787935&ev=PageView&noscript=1" />`}
          </noscript>
          {/* <!-- LinkedIn Insight Tag --> */}
          <script type="text/javascript">
            {`_linkedin_partner_id = "1408252"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id);`}
          </script>
          <noscript>
            {`
            <img
              height="1"
              width="1"
              style="display:none"
              alt=""
              src="https://px.ads.linkedin.com/collect/?pid=1408252&fmt=gif"
            />
            `}
          </noscript>
          {/* <!-- Pinterest Pixel Base Code --> */}
          <script type="text/javascript">
            {`!function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(
              Array.prototype.slice.call(arguments))};var
              n=window.pintrk;n.queue=[],n.version="3.0";var
              t=document.createElement("script");t.async=!0,t.src=e;var
              r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
              pintrk('load', '2614076304576');
              pintrk('page');`}
          </script>
          <noscript>
            {`
            <img
              height="1"
              width="1"
              style="display:none"
              alt=""
              src="https://ct.pinterest.com/v3/?tid=2614076304576&event=init&noscript=1"
            />
            `}
          </noscript>
          {/* <!-- Twitter universal website tag code --> */}
          <script>
            {`!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
              },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
              a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
              // Insert Twitter Pixel ID and Standard Event data below
              twq('init','o2cm7');
              twq('track','PageView');`}
          </script>
          {!!auth && (
            <script type="text/javascript">
              {`
                var identifyHeap = function() {
                  if (typeof heap === 'undefined') {
                    setTimeout(identifyHeap, 500);
                  } else {
                    heap.identify('${escape(auth.display_name || '')}${auth.id}');
                    heap.addUserProperties({ almanac_user_id: '${auth.id}' });
                  }
                }
                identifyHeap()
              `}
            </script>
          )}
          {!!auth && (
            <script>
              {`
            // This is an example script - don't forget to change it!
            typeof FS !== 'undefined' && FS.identify('${auth.id}', {
              displayName: '${escape(auth.display_name || '')}',
              email: '${auth.email}',
              // TODO: Add your own custom user variables here, details at
            });
            `}
            </script>
          )}
        </Helmet>
        {children}
      </>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const auth = state.auth
  return { auth }
}

export default connect(mapStateToProps, null)(TrackingPixels)
